import React from "react";
import { Section } from "@/layout/Section";
import { useT } from "@/hooks/useT";
import { SimplePage } from "@/layout/SimplePage";
import loginClip from "../../assets/cliparts/login.svg";
import { LinkLoginForm } from "./LinkLoginForm";
import { Grid } from "@mui/material";

interface LoginTemplateProps {
  step: number;
  children: React.ReactNode;
}

export const LoginTemplate: React.FC<LoginTemplateProps> = ({
  step,
  children,
}) => {
  const { t } = useT();

  return (
    <SimplePage>
      <Grid container>
        <Grid item xs={12} md={6}>
          <Section title={t("page.login.title")}>
            <p>
              {t(
                step === 1
                  ? "page.login.description"
                  : step === 2
                    ? "page.login.codeDescription"
                    : "page.login.confirmDescription",
              )}
            </p>
          </Section>
        </Grid>
        <Grid item xs={12} md={6} />
        {step < 3 && <Grid item xs={12} sx={{ mt: 6 }} />}
        <Grid item xs={12} md={6}>
          {children}
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: {
              xs: "none",
              md: "block",
            },
          }}
        >
          <img
            src={loginClip}
            alt={"Login Clipart"}
            style={{ maxWidth: "100%" }}
          />
        </Grid>
      </Grid>
    </SimplePage>
  );
};

export const Login: React.FC = () => {
  const { t } = useT();
  const [step, setStep] = React.useState(1);
  return (
    <LoginTemplate step={step}>
      <LinkLoginForm setStep={setStep} />
    </LoginTemplate>
  );
};
